<div [class]="'casino-slider-main ' + this.pageName + '-game-container'">
  <div class="slider-header">
    <span>{{ this.providerName }}</span>
  </div>
  <button class="nav-button-slider prev" (click)="prev()" [disabled]="currentIndex - itemsPerPage < 0">
    <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon left'"></image-loader-utils>
  </button>
  <button class="nav-button-slider next" (click)="next()" [disabled]="currentIndex + itemsPerPage >= items.length">
    <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon right'"></image-loader-utils>
  </button>
  <ng-container *ngIf="this.pageName === 'dialog'">
    <button class="nav-button-slider-lobby up" (click)="upDownButtonAction()">
      <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (this.isSliderMenu ? 'down' : '')"></image-loader-utils>
    </button>
  </ng-container>
  <div class="casino-slider-container">
    <div class="slider-wrapper mobil-disabled">
      <div class="slider-content" [style.transform]="'translateX(' + -currentIndex * 149 + 'px)'">
        <div class="slider-item" *ngFor="let item of items">
          <div class="image-body">
            <casino-image-util [assetsPath]="environment.assetsPath" [cardData]="item" [isOnLoad]="false"></casino-image-util>
          </div>
        </div>
      </div>
    </div>
    <div class="slider-wrapper mobil">
      <div class="slider-content">
        <div class="slider-item" *ngFor="let item of items">
          <div class="image-body" (click)="this.goGamesMobilAction(item)">
            <casino-image-util [assetsPath]="environment.assetsPath" [cardData]="item" [isOnLoad]="false"></casino-image-util>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
